module.exports = __webpack_public_path__ + "img/reset_power_step_2.e66b801f.png";